import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-style-two',
  templateUrl: './contact-style-two.component.html',
  styleUrls: ['./contact-style-two.component.scss']
})
export class ContactStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
